import script from "./Completion2ElectricOptions.vue?vue&type=script&lang=ts&setup=true"
export * from "./Completion2ElectricOptions.vue?vue&type=script&lang=ts&setup=true"

import "./Completion2ElectricOptions.vue?vue&type=style&index=0&id=624c2be6&lang=less&scoped=true"

import exportComponent from "/var/build/production/buyers-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-624c2be6"]])

export default __exports__